import React, { useState } from 'react';
import { Form, Input, Alert } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useSignUp } from '../context/SignUpContext';
import StepNavigation from '../components/StepNavigation';
import { registerUser } from '../../../../api/signup';

const StepAccountCreate = () => {
  const [form] = Form.useForm();
  const { formData, updateField, setUserData, nextStep } = useSignUp();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      setError(null);

      const userData = await registerUser(values.email, values.password);

      updateField('email', values.email);
      updateField('password', values.password);
      setUserData(userData);

      nextStep();
    } catch (err) {
      setLoading(false);
      if (err.errorFields) {
        // Form validation error
        return;
      }

      // API error
      if (err.message?.email) {
        setError(err.message.email[0]);
      } else if (err.message?.password) {
        setError(err.message.password[0]);
      } else if (err.message?.detail) {
        setError(err.message.detail);
      } else {
        setError('Ocorreu um erro ao criar sua conta. Tente novamente.');
      }
    }
  };

  return (
    <div className="step-content">
      <div className="step-header">
        <h2>Crie sua conta</h2>
        <p>Comece criando seu acesso. Depois, vamos cadastrar seu negócio.</p>
      </div>

      <Form
        form={form}
        layout="vertical"
        initialValues={{
          email: formData.email,
          password: formData.password,
        }}
        requiredMark={false}
      >
        <Form.Item
          name="email"
          label="E-mail"
          rules={[
            { required: true, message: 'Digite seu e-mail' },
            { type: 'email', message: 'Digite um e-mail válido' },
          ]}
        >
          <Input
            prefix={<MailOutlined />}
            placeholder="seu@email.com"
            size="large"
            autoComplete="email"
          />
        </Form.Item>

        <Form.Item
          name="password"
          label="Senha"
          rules={[
            { required: true, message: 'Digite sua senha' },
            { min: 8, message: 'A senha deve ter no mínimo 8 caracteres' },
          ]}
          extra="Mínimo de 8 caracteres"
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Crie uma senha segura"
            size="large"
            autoComplete="new-password"
          />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Confirme sua senha"
          dependencies={['password']}
          rules={[
            { required: true, message: 'Confirme sua senha' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('As senhas não coincidem'));
              },
            }),
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Digite a senha novamente"
            size="large"
            autoComplete="new-password"
          />
        </Form.Item>

        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            closable
            onClose={() => setError(null)}
            style={{ marginBottom: 16 }}
          />
        )}
      </Form>

      <StepNavigation
        onNext={handleSubmit}
        showBack={false}
        loading={loading}
        nextText="Criar conta"
      />
    </div>
  );
};

export default StepAccountCreate;
